import React, { useEffect, useState } from 'react';
import { assignmentAPI } from '../api';
import { toast } from 'sonner';

export const AssignmentIntelligencePage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    assignmentAPI.intelligence().then(r => setData(r.data)).catch(() => toast.error('Failed to load assignment intelligence')).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-96"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div></div>;
  if (!data) return null;

  return (
    <div className="space-y-6" data-testid="assignment-intelligence-page">
      <div>
        <h1 className="text-3xl font-outfit font-semibold">Assignment Intelligence</h1>
        <p className="text-muted-foreground mt-1">Explainable, database-derived workload & performance to guide lead assignment. Final choice stays with you.</p>
      </div>
      {data.recommended_reason && (
        <div className="clay-card p-4 border-l-4 border-primary" data-testid="ai-recommended">
          <p className="text-sm"><span className="font-medium">Recommended:</span> {(data.executives.find(e => e.user_id === data.recommended_user_id) || {}).name} — {data.recommended_reason}</p>
        </div>
      )}
      <div className="clay-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 dark:bg-slate-800/50 text-left">
            <tr>{['Executive', 'Active', 'Pending FU', 'Overdue FU', 'Hot', 'Won', 'Conversion', 'Avg Close (d)', 'Workload', 'Score'].map(h => <th key={h} className="px-3 py-3 font-medium">{h}</th>)}</tr>
          </thead>
          <tbody>
            {data.executives.map(e => (
              <tr key={e.user_id} className={`border-t border-slate-100 dark:border-slate-800 ${e.user_id === data.recommended_user_id ? 'bg-primary/5' : ''}`} data-testid="ai-row">
                <td className="px-3 py-2 font-medium">{e.name} <span className="text-xs text-muted-foreground">{e.login_user_id}</span></td>
                <td className="px-3 py-2">{e.active_leads}</td>
                <td className="px-3 py-2">{e.pending_follow_ups}</td>
                <td className={`px-3 py-2 ${e.overdue_follow_ups > 0 ? 'text-red-600 font-medium' : ''}`}>{e.overdue_follow_ups}</td>
                <td className="px-3 py-2">{e.hot_leads}</td>
                <td className="px-3 py-2">{e.won_leads}</td>
                <td className="px-3 py-2">{e.conversion_rate}%</td>
                <td className="px-3 py-2">{e.avg_closing_days ?? '\u2014'}</td>
                <td className="px-3 py-2">{e.current_workload}</td>
                <td className="px-3 py-2 font-medium">{e.score}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default AssignmentIntelligencePage;
